
/* styles */
require("!!../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../vue-loader/lib/style-compiler/index?{\"id\":\"data-v-315b1b92\",\"scoped\":false,\"hasInlineConfig\":true}!../../vue-loader/lib/selector?type=styles&index=0!./ClipLoader.vue")

var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vue-loader/lib/selector?type=script&index=0!./ClipLoader.vue"),
  /* template */
  require("!!../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-315b1b92\"}!../../vue-loader/lib/selector?type=template&index=0!./ClipLoader.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-spinner/src/ClipLoader.vue
// module id = 1427
// module chunks = 1